import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './redux/store';

// Suppress noisy ResizeObserver warnings that can trigger CRA runtime overlay.
const resizeObserverErrorPattern = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)\.?/i;
const shouldSuppressResizeObserverError = (message) =>
  typeof message === 'string' && resizeObserverErrorPattern.test(message);

window.addEventListener('error', (event) => {
  const message = event?.message || event?.error?.message;
  if (shouldSuppressResizeObserverError(message)) {
    event.preventDefault?.();
    event.stopImmediatePropagation?.();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  const message = typeof reason === 'string' ? reason : reason?.message;
  if (shouldSuppressResizeObserverError(message)) {
    event.preventDefault();
  }
});

if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const first = args?.[0];
    const message = typeof first === 'string' ? first : first?.message;
    if (shouldSuppressResizeObserverError(message)) return;
    originalConsoleError(...args);
  };
}

ReactDOM.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
